<template lang="pug">
	.page
			.wrapper
				list-section(
					v-for="(list, index) in cultures_by_category"
					:key="index"
					:title="list.name"
					:list="list.cultures"
					:type="'culture'"
					:link="'/cultures/'"
				)
				button.btn-top(data-aos="fade-up" @click="scrollTop()") Вгору
</template>

<script>

  let collectionSlug = 'cultures_by_category';

	import ListSection from '@/components/listSection.vue';

	import AOS from 'aos';

	import {mapState} from 'vuex';

	export default {
		name: collectionSlug,
		metaInfo: function() {
			return {
				title: 'Культури'
			}
		},
		created() {
			if (!this[collectionSlug].length) this.$store.dispatch('GET_COLLECTION', collectionSlug);
		},
		methods: {
			scrollTop() {
				window.scroll({
					top: 0, 
					left: 0, 
					behavior: 'smooth'
				});
			}
		},
		components: {
			'list-section': ListSection,
		},
		mounted() {
			this.$nextTick(() => {
				AOS.init({
					once: true,
					disabled: 'mobile',
					duration: 1000
				});
			})
		},
		computed: {
			...mapState([
				collectionSlug,
			])
		}
	}

</script>

<style lang="scss" scoped>
	.btn-top {
		height: 30px;
		background-color: #EF3E33;
		color: #fff;
		font: 500 14px 'Helvetica', Arial, sans-serif;
		letter-spacing: 1px;
		width: 157px;
		margin: -12px auto 100px;
		display: none;
		
		@media screen and (min-width: 1201px) {
			&:hover {
				opacity: .7!important;
				transition: opacity .3s ease;
			}
		}
	}

	.page {
		margin-bottom: 80px;
	}

	@media screen and (max-width: 1200px) {
		.btn-top {
			display: block;
		}
	}
</style>
